/**
 * Shared Package Initialization (Web)
 *
 * Initialize the @prosperia/shared package with web-specific adapters.
 * This must be called before any shared code is used.
 */

import {
  setPlatform,
  setStorageAdapter,
  createStorageAdapter,
  setEnvAdapter,
  initializeSupabase,
} from '@prosperia/shared';

let initialized = false;

/**
 * Initialize the shared package for web
 */
export function initializeSharedPackage() {
  if (typeof window === 'undefined') return;

  if (initialized) {
    console.log('[SharedInit] Already initialized');
    return;
  }

  console.log('[SharedInit] Initializing shared package for web...');

  // 1. Set platform
  setPlatform('web');

  // 2. Set storage adapter (use localStorage)
  setStorageAdapter(createStorageAdapter(window.localStorage));

  // 3. Set environment variables
  setEnvAdapter({
    // Supabase
    SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,

    // Stripe
    STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
    STRIPE_TEST_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_TEST_PUBLISHABLE_KEY,

    // Firebase
    FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
    FIREBASE_VAPID_KEY: import.meta.env.VITE_FIREBASE_VAPID_KEY,

    // Google Maps
    GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  });

  // 4. Initialize Supabase with web-specific options
  initializeSupabase({
    storage: window.localStorage,
    redirectUrl: `${window.location.origin}/dashboard`,
  });

  initialized = true;
  console.log('[SharedInit] Shared package initialized successfully');
}

/**
 * Check if shared package is initialized
 */
export function isSharedInitialized() {
  return initialized;
}

// Auto-initialize when this module is imported (browser only)
if (typeof window !== 'undefined') {
  initializeSharedPackage();
}

export default initializeSharedPackage;
